import { render, staticRenderFns } from "./LatihanFinal2.vue?vue&type=template&id=2976df98&scoped=true"
import script from "./LatihanFinal2.vue?vue&type=script&lang=js"
export * from "./LatihanFinal2.vue?vue&type=script&lang=js"
import style0 from "./LatihanFinal2.vue?vue&type=style&index=0&id=2976df98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2976df98",
  null
  
)

export default component.exports